/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_TitleInputs */

const en_tasks_title = /** @type {(inputs: Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

const pt_br2_tasks_title = /** @type {(inputs: Tasks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividades`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Tasks_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_title = /** @type {((inputs?: Tasks_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_title(inputs)
	return pt_br2_tasks_title(inputs)
});